import { Suspense, lazy, useState, useEffect, useRef, MouseEvent as ReactMouseEvent, PointerEvent as ReactPointerEvent } from 'react'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'
import { AuthPage } from '../modules/auth'
import Noticias from './public/noticias/index'
import InfoPublica from './public/informacionPublica'
import QuienesSomos from './public/quienesSomos'
import Contacto from './public/contacto'
import GaleriaPublic from './public/Galeria/index'
import ProgramaCEA from './public/programaCEA'
import Sedes from '../views/Sedes/Sedes'


import { toAbsoluteUrl } from '../../_metronic/helpers'
import { Col, Row } from 'react-bootstrap-v5';

export function PublicRoutes() {
  const BuilderPageWrapper = lazy(() => import('../views/Landing/index'))
  const history = useHistory();
  const headerRef = useRef<HTMLDivElement | null>(null)
  const atletasDropdownRef = useRef<HTMLDivElement | null>(null)
  const quienesDropdownRef = useRef<HTMLDivElement | null>(null)
  const [width, setWidth] = useState(window.innerWidth),
    handleResize = () => {
      setWidth(window.innerWidth);
    }
  const [mobileDrawerTop, setMobileDrawerTop] = useState(0)
  const [isAtletasMenuOpen, setIsAtletasMenuOpen] = useState(false)
  const [isQuienesMenuOpen, setIsQuienesMenuOpen] = useState(false)
  const isMobile = width <= 991 || window.matchMedia('(max-width: 991.98px)').matches

  const measureHeader = () => {
    if (headerRef.current) {
      setMobileDrawerTop(headerRef.current.getBoundingClientRect().height)
    }
  }

  const closeMobileDrawer = () => {
    if (window.innerWidth > 991) {
      return
    }

    const drawer = document.querySelector('.landing-menu-wrapper.drawer') as HTMLElement | null
    if (drawer) {
      drawer.classList.remove('drawer-on')
      drawer.style.transform = ''
    }

    document.querySelectorAll('.drawer-overlay').forEach((overlay) => overlay.remove())
    document.body.removeAttribute('data-kt-drawer')

    const toggleButton = document.getElementById('kt_landing_menu_toggle') as HTMLButtonElement | null
    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', 'false')
    }
  }

  const closeAllMenus = () => {
    setIsAtletasMenuOpen(false)
    setIsQuienesMenuOpen(false)

    document
      .querySelectorAll('details.fdna-mobile-disclosure[open]')
      .forEach((detail) => detail.removeAttribute('open'))

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur()
    }

    closeMobileDrawer()
  }

  const handleMobileSubmenuItemCapture = (event: ReactMouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement
    if (target.closest('a')) {
      closeAllMenus()

      // Some external-link flows can re-apply disclosure state after click;
      // run once more in next tick to guarantee collapse on mobile.
      window.setTimeout(() => {
        document
          .querySelectorAll('details.fdna-mobile-disclosure[open]')
          .forEach((detail) => detail.removeAttribute('open'))
      }, 0)
    }
  }

  const toggleQuienesMenu = (event: ReactMouseEvent<HTMLButtonElement> | ReactPointerEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setIsAtletasMenuOpen(false)
    setIsQuienesMenuOpen((prev) => !prev)
  }

  const toggleAtletasMenu = (event: ReactMouseEvent<HTMLButtonElement> | ReactPointerEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setIsQuienesMenuOpen(false)
    setIsAtletasMenuOpen((prev) => !prev)
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    measureHeader()
    window.addEventListener('resize', measureHeader)

    return () => {
      window.removeEventListener('resize', measureHeader)
    }
  }, [width])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (window.innerWidth <= 991) {
        return
      }

      if (atletasDropdownRef.current && !atletasDropdownRef.current.contains(event.target as Node)) {
        setIsAtletasMenuOpen(false)
      }
      if (quienesDropdownRef.current && !quienesDropdownRef.current.contains(event.target as Node)) {
        setIsQuienesMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    setIsAtletasMenuOpen(false)
    setIsQuienesMenuOpen(false)
  }, [history.location.pathname])
  return (
    <Suspense fallback={<FallbackView />}>
      <div className='landing-container'>
        <div className="d-flex flex-column flex-root" id="kt_app_root">
          {/*begin::Header Section*/}
          <div className="mb-0" id="home">
            {/*begin::Wrapper*/}
            <div className="fdna-landing-shell">
              {/*begin::Header*/}
              <div
                ref={headerRef}
                className="landing-header navbar-fdna"
                data-kt-sticky="true"
                data-kt-sticky-name="landing-header"
                data-kt-sticky-offset="{default: '300px', lg: '400px'}"
              >
                {/*begin::Container*/}
                <div className="container">
                  {/*begin::Wrapper*/}
                  <div className="d-flex align-items-center justify-content-between">
                    {/*begin::Logo*/}
                    <div className="d-flex align-items-center flex-equal text-center"
                      style={{ justifyContent: `${width <= 991 ? 'space-between' : ''}` }}
                    >
                      {/*begin::Mobile menu toggle*/}
                      <button
                        className="btn btn-icon btn-active-color-primary me-3 d-flex d-lg-none text-end"
                        id="kt_landing_menu_toggle"
                        onClick={measureHeader}
                      >
                        <span className="svg-icon svg-icon-2hx text-dark">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={16}
                            height={16}
                            fill="currentColor"
                            className="bi bi-list"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                            />
                          </svg>

                        </span>
                      </button>
                      {/*end::Mobile menu toggle
                                            {/*begin::Logo image*/}
                      <Row style={{ justifyContent: `${width <= 800 ? 'center' : ''}` }}>
                        <Col>

                          <a href="/inicio" className='d-flex justify-content-center'>
                            <div className='text-center'>
                              <img
                                alt="Logo"
                                src={toAbsoluteUrl('/media/logos/LOGO-OFICIAL-2023-dark.png')}
                                className="logo-default h-95px h-lg-120px"
                              />
                            </div>
                            <div className='text-center'>
                              <img
                                alt="Logo"
                                src={toAbsoluteUrl('/media/logos/LOGO-OFICIAL-2023-dark.png')}
                                className="logo-sticky h-95px h-lg-120px text-center"
                              />
                            </div>
                          </a>
                        </Col>
                      </Row>
                      <div></div>

                      {/*end::Logo image*/}
                    </div>
                    {/*end::Logo*/}
                    {/*begin::Menu wrapper*/}
                    <div className="d-lg-block" id="kt_header_nav_wrapper">
                      <div
                        className="landing-menu-wrapper d-lg-block p-5 p-lg-0"
                        data-kt-drawer="true"
                        data-kt-drawer-name="landing-menu"
                        data-kt-drawer-activate="{default: true, lg: false}"
                        data-kt-drawer-overlay="true"
                        data-kt-drawer-width="200px"
                        data-kt-drawer-direction="start"
                        data-kt-drawer-toggle="#kt_landing_menu_toggle"
                        style={isMobile ? { top: `${mobileDrawerTop}px`, height: `calc(100vh - ${mobileDrawerTop}px)` } : undefined}
                      >
                        {/*begin::Menu*/}
                        <div
                          className="menu menu-column flex-nowrap menu-rounded menu-lg-row menu-title-dark-500 menu-state-title-dark nav nav-flush fs-5 fw-semibold"
                          id="kt_landing_menu"
                        >
                          {isMobile ? (
                            <>
                              <div className="menu-item">
                                <a href="/inicio">
                                  <span
                                    className={`menu-link nav-link fdna-nav-link ${history?.location?.pathname?.includes(String('inicio')) ? 'active' : null} py-3 px-4 px-xxl-6`}
                                    data-kt-scroll-toggle="true"
                                    data-kt-drawer-dismiss="true"
                                  >
                                    Inicio
                                  </span>
                                </a>
                              </div>
                              <details className="menu-item fdna-mobile-disclosure">
                                <summary
                                  className={`menu-link nav-link fdna-nav-link fdna-dropdown-toggle ${history?.location?.pathname?.includes(String('quienes-somos')) ? 'active' : ''} py-3 px-4 px-xxl-6`}
                                >
                                  Quiénes somos
                                  <span aria-hidden="true">▾</span>
                                </summary>
                                <div className="fdna-mobile-submenu-list" onClickCapture={handleMobileSubmenuItemCapture}>
                                  <a href="/quienes-somos" data-kt-drawer-dismiss="true" onTouchStart={closeAllMenus} onMouseDown={closeAllMenus} onPointerDown={closeAllMenus} onClick={closeAllMenus}>
                                    Quiénes somos
                                  </a>
                                  <a
                                    href="/quienes-somos/unidad-de-atencion-integral-al-atleta"
                                    data-kt-drawer-dismiss="true"
                                    onTouchStart={closeAllMenus}
                                    onMouseDown={closeAllMenus}
                                    onPointerDown={closeAllMenus}
                                    onClick={closeAllMenus}
                                  >
                                    Unidad de Atención Integral al Atleta
                                  </a>
                                </div>
                              </details>
                              <div className="menu-item">
                                <a href="/fotos-y-videos">
                                  <span
                                    className={`menu-link nav-link fdna-nav-link ${history?.location?.pathname?.includes(String('fotos-y-videos')) ? 'active' : null} py-3 px-4 px-xxl-6`}
                                    data-kt-scroll-toggle="true"
                                    data-kt-drawer-dismiss="true"
                                  >
                                    Fotos y Videos
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="/sedes">
                                  <span
                                    className={`menu-link nav-link fdna-nav-link ${history?.location?.pathname?.includes(String('sedes')) ? 'active' : null} py-3 px-4 px-xxl-6`}
                                    data-kt-scroll-toggle="true"
                                    data-kt-drawer-dismiss="true"
                                  >
                                    Sedes de Entrenamiento
                                  </span>
                                </a>
                              </div>
                              <details className="menu-item fdna-mobile-disclosure">
                                <summary className="menu-link nav-link fdna-nav-link fdna-dropdown-toggle py-3 px-4 px-xxl-6">
                                  Atletas
                                  <span aria-hidden="true">▾</span>
                                </summary>
                                <div className="fdna-mobile-submenu-list" onClickCapture={handleMobileSubmenuItemCapture}>
                                  <a href="/programa-cea" data-kt-drawer-dismiss="true" onTouchStart={closeAllMenus} onMouseDown={closeAllMenus} onPointerDown={closeAllMenus} onClick={closeAllMenus}>
                                    Programa CEA
                                  </a>
                                  <a
                                    href="https://resultados.fdna.gt"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-kt-drawer-dismiss="true"
                                    onTouchStart={closeAllMenus}
                                    onMouseDown={closeAllMenus}
                                    onPointerDown={closeAllMenus}
                                    onClick={closeAllMenus}
                                  >
                                    Resultados
                                  </a>
                                  <a
                                    href="https://estadisticas.fdna.gt"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-kt-drawer-dismiss="true"
                                    onTouchStart={closeAllMenus}
                                    onMouseDown={closeAllMenus}
                                    onPointerDown={closeAllMenus}
                                    onClick={closeAllMenus}
                                  >
                                    Estadísticas
                                  </a>
                                  <a
                                    href="https://afiliaciones.fdna.gt"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-kt-drawer-dismiss="true"
                                    onTouchStart={closeAllMenus}
                                    onMouseDown={closeAllMenus}
                                    onPointerDown={closeAllMenus}
                                    onClick={closeAllMenus}
                                  >
                                    Afiliaciones
                                  </a>
                                </div>
                              </details>
                            </>
                          ) : (
                            <>
                              <div className="menu-item">
                                <a href="/inicio">
                                  <span
                                    className={`menu-link nav-link fdna-nav-link ${history?.location?.pathname?.includes(String('inicio')) ? 'active' : null} py-3 px-4 px-xxl-6`}
                                    data-kt-scroll-toggle="true"
                                    data-kt-drawer-dismiss="true"
                                  >
                                    Inicio
                                  </span>
                                </a>
                              </div>
                              <div
                                className={`menu-item fdna-dropdown ${isQuienesMenuOpen ? 'open' : ''}`}
                                ref={quienesDropdownRef}
                              >
                                <button
                                  type="button"
                                  className={`menu-link nav-link fdna-nav-link fdna-dropdown-toggle ${history?.location?.pathname?.includes(String('quienes-somos')) ? 'active' : ''} py-3 px-4 px-xxl-6`}
                                  aria-expanded={isQuienesMenuOpen}
                                  onPointerUp={toggleQuienesMenu}
                                >
                                  Quiénes somos
                                  <span aria-hidden="true">▾</span>
                                </button>
                                <div className="fdna-dropdown-menu">
                                  <a href="/quienes-somos" data-kt-drawer-dismiss="true" onClick={closeAllMenus}>
                                    Quiénes somos
                                  </a>
                                  <a
                                    href="/quienes-somos/unidad-de-atencion-integral-al-atleta"
                                    data-kt-drawer-dismiss="true"
                                    onClick={closeAllMenus}
                                  >
                                    Unidad de Atención Integral al Atleta
                                  </a>
                                </div>
                              </div>
                              <div className="menu-item">
                                <a href="/fotos-y-videos">
                                  <span
                                    className={`menu-link nav-link fdna-nav-link ${history?.location?.pathname?.includes(String('fotos-y-videos')) ? 'active' : null} py-3 px-4 px-xxl-6`}
                                    data-kt-scroll-toggle="true"
                                    data-kt-drawer-dismiss="true"
                                  >
                                    Fotos y Videos
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="/sedes">
                                  <span
                                    className={`menu-link nav-link fdna-nav-link ${history?.location?.pathname?.includes(String('sedes')) ? 'active' : null} py-3 px-4 px-xxl-6`}
                                    data-kt-scroll-toggle="true"
                                    data-kt-drawer-dismiss="true"
                                  >
                                    Sedes de Entrenamiento
                                  </span>
                                </a>
                              </div>
                              <div
                                className={`menu-item fdna-dropdown ${isAtletasMenuOpen ? 'open' : ''}`}
                                ref={atletasDropdownRef}
                              >
                                <button
                                  type="button"
                                  className="menu-link nav-link fdna-nav-link fdna-dropdown-toggle py-3 px-4 px-xxl-6"
                                  aria-expanded={isAtletasMenuOpen}
                                  onPointerUp={toggleAtletasMenu}
                                >
                                  Atletas
                                  <span aria-hidden="true">▾</span>
                                </button>
                                <div className="fdna-dropdown-menu">
                                  <a href="/programa-cea" data-kt-drawer-dismiss="true" onClick={closeAllMenus}>
                                    Programa CEA
                                  </a>
                                  <a
                                    href="https://resultados.fdna.gt"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-kt-drawer-dismiss="true"
                                    onClick={closeAllMenus}
                                  >
                                    Resultados
                                  </a>
                                  <a
                                    href="https://estadisticas.fdna.gt"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-kt-drawer-dismiss="true"
                                    onClick={closeAllMenus}
                                  >
                                    Estadísticas
                                  </a>
                                  <a
                                    href="https://afiliaciones.fdna.gt"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-kt-drawer-dismiss="true"
                                    onClick={closeAllMenus}
                                  >
                                    Afiliaciones
                                  </a>
                                </div>
                              </div>
                            </>
                          )}
                          {/* <div className="menu-item">
                            <a href="/news/public">
                              <span
                                className={`menu-link nav-link text-white text-hover-dark ${history?.location?.pathname?.includes(String('news/public')) ? 'active' : null} py-3 px-4 px-xxl-6`}
                                data-kt-scroll-toggle="true"
                                data-kt-drawer-dismiss="true"
                              >
                                Noticias
                              </span>
                            </a>

                          </div> */}



                          <div className="menu-item">
                            <a href="/informacion-publica-de-oficio">
                              <span
                                className={`menu-link nav-link fdna-nav-link ${history?.location?.pathname?.includes(String('federaciones-y-asociaciones')) ? 'active' : null} py-3 px-4 px-xxl-6`}
                                data-kt-scroll-toggle="true"
                                data-kt-drawer-dismiss="true"
                              >
                                Información Pública de Oficio
                              </span>
                            </a>
                          </div>


                          {/* <div className="menu-item">
                            <a href="/contacto">
                              <span
                                className={`menu-link nav-link text-white text-hover-dark ${history?.location?.pathname?.includes(String('contacto')) ? 'active' : null} py-3 px-4 px-xxl-6`}
                                data-kt-scroll-toggle="true"
                                data-kt-drawer-dismiss="true"
                              >
                                Contacto
                              </span>
                            </a>
                          </div> */}

                        </div>
                        {/*end::Menu*/}
                      </div>
                    </div>
                    {/*end::Menu wrapper*/}
                  </div>
                  {/*end::Wrapper*/}
                </div>
                {/*end::Container*/}
              </div>
              {/*end::Header*/}
              <Switch>
                <Route path='/inicio' component={BuilderPageWrapper} />
                <Route path='/auth' component={AuthPage} />
                <Route path='/news' component={Noticias} />
                <Route path='/quienes-somos/unidad-de-atencion-integral-al-atleta' component={QuienesSomos} />
                <Route path='/quienes-somos' component={QuienesSomos} />
                <Route path='/programa-cea' component={ProgramaCEA} />
                <Route path='/contacto' component={Contacto} />
                <Route path='/informacion-publica-de-oficio' component={InfoPublica} />
                <Route path='/fotos-y-videos' component={GaleriaPublic} />
                <Route path='/sedes' component={Sedes} />

                <Redirect from='/news' to='/news/public' />
                <Redirect exact from='/' to='/inicio' />
              </Switch>
              {/* FOOTER INICIO */}
              <div className="mb-0" >

                {/*begin::Wrapper*/}
                <div className="pt-20 footer-fdna">
                  {/*begin::Container*/}
                  <div className="pe-20 ps-20">
                    {/*begin::Row*/}
                    <Row className="py-10 py-lg-20 justify-content-between">
                      {/*begin::Col IZQUIERDO*/}
                      <Col xs={12} lg={4} >
                        {/*begin::Block*/}
                        <div className="mb-10">
                          {/*begin::Title*/}
                          <h2 className="text-white fs-1">Ubicación</h2>
                          {/*end::Title*/}
                          {/*begin::Text*/}
                          <a href="https://ul.waze.com/ul?ll=14.62537174%2C-90.51085353&navigate=yes&zoom=17&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location" target="_blank" rel="noopener noreferrer">
                            <span className="fw-normal fs-5 text-white">
                              {/* <img
                                src={toAbsoluteUrl("/media/icons/FDNRC/ubicacionfooter.png")}
                                alt="Logo"
                                width={40}
                                height={40}
                                className=''
                              >
                              </img> */}
                              &nbsp; &nbsp;Interior Estadio Nacional Doroteo Guamuch Flores, Zona 5, Ciudad de Guatemala
                            </span>
                          </a>
                          {/*end::Text*/}
                        </div>
                        {/*end::Block*/}
                        {/*begin::Block*/}
                        <div >
                         
                          {/*begin::Title*/}
                          <h2 className="text-white fs-1">Contacto</h2>
                          {/*end::Title*/}
                          {/*begin::Text*/}
                          {/* <div className='p-0 m-0'>
                            <span className="fw-normal fs-4 text-white">

                              &nbsp; &nbsp;PBX: +502 2296 6263
                            </span>
                          </div> */}
                          <div className='p-0 m-0'>
                            <span className="fw-normal fs-4 text-white">
                              &nbsp; &nbsp;Tel: +502 22966262
                            </span>
                          </div>
                          <div className='p-0 m-0'>
                            <span className="fw-normal fs-4 text-white">
                              &nbsp; &nbsp;Tel: +502 22966263
                            </span>
                          </div>
                          <div className='pb-5'>                          </div>
                          
                          <div className="mb-10">
                            {/*begin::Title*/}
                            <h2 className="text-white fs-1">Unidad de Información Pública</h2>
                            {/*end::Title*/}
                            {/*begin::Text*/}
                            <a href="mailto:informacion@fdna.gt" target="_blank" rel="noopener noreferrer">
                              <span className="fw-normal fs-4 text-white">
                                &nbsp;&nbsp;informacion@fdna.gt
                              </span>
                            </a>
                            {/*end::Text*/}
                          </div>
                          <span
                            className="fw-normal fs-4 text-white"
                          >
                            &nbsp;&nbsp;Horario de Atención:<br />
                            &nbsp;&nbsp;Lunes a Viernes: 08:00 a 16:00 horas<br />

                          </span>
                          <div className='pb-5'>                          </div>
                          <span
                            className="fw-normal fs-4 text-white"
                          >
                            &nbsp;&nbsp;Horario Recepción de Documentación: <br />

                            &nbsp;&nbsp;Lunes a Viernes: 08:00 a 16:00 horas<br />

                          </span>
                          {/*end::Text*/}
                        </div>
                        {/*end::Block*/}
                      </Col>
                      {/*end::Col*/}
                      {/*begin::Col CENTRO*/}
                      <Col xs={12} lg={4} className='p-10'>
                        <div className='d-flex justify-content-center'>
                          <img
                            alt="Logo"
                            src={toAbsoluteUrl('/media/logos/LOGO-OFICIAL-2023-white.png')}
                            style={{ height: `${width <= 800 ? '25vh' : '15vw'}` }}
                          />
                        </div>
                        <Row className='text-center text-white mt-5'>
                          <Col className='m-0 p-0'>

                            <a href="https://www.instagram.com/atletismogt" className='text-white p-5'>
                              <img
                                src={toAbsoluteUrl("/media/icons/COG/instagram.png")}
                                alt="Logo"
                                width={40}
                                height={40}
                              >
                              </img>
                            </a>

                          </Col>
                          <Col className='m-0 p-0'>


                            <a href="https://x.com/fnatletismogt" className='text-white'>
                              <img
                                src={toAbsoluteUrl("/media/icons/COG/twitter.png")}
                                alt="Logo"
                                width={48}
                                height={48}
                              >
                              </img>
                            </a>
                          </Col>
                          <Col className='m-0 p-0'>

                            <a href="https://www.facebook.com/FNAGuatemala" className='text-white'>
                              <img
                                src={toAbsoluteUrl("/media/icons/COG/facebook.png")}
                                alt="Logo"
                                width={40}
                                height={40}
                              >
                              </img>
                            </a>

                          </Col>

                          {/* <Col className='m-0 p-0'>
                            <a href="https://youtube.com/@remocanotajeguate?si=CMarBoFqJyHG_GnJ" className='text-white'>
                              <img
                                src={toAbsoluteUrl("/media/icons/COG/youtube.png")}
                                alt="Logo"
                                width={40}
                                height={40}
                              >
                              </img>
                            </a>

                          </Col> */}
                        </Row>
                      </Col>
                      {/*begin::Col DERECHO*/}
                      <Col xs={12} lg={4} className="text-end cambia-tamaño">
                        {/*begin::Navs*/}
                        <div >
                          {/*begin::Links*/}
                          <div className="d-flex fw-semibold flex-column">
                            {/*begin::Subtitle*/}

                            {/*end::Subtitle*/}
                            {/*begin::Link*/}
                            <span
                              onClick={() => history.push(`${`/quienes-somos`}`)}
                              className="text-white  text-white text-hover-dark fs-5 mb-6"
                            >
                              Quiénes somos
                            </span>
                            {/*end::Link*/}
                            {/*begin::Link*/}
                            {/* <span
                              onClick={() => history.push(`${`/legislacion`}`)}
                              className="text-white  text-white text-hover-dark fs-5 mb-6"
                            >
                              Legislación
                            </span> */}
                            {/* <span
                              onClick={() => history.push(`${`/news/public`}`)}
                              className="text-white  text-white text-hover-dark fs-5 mb-6"
                            >
                              Noticias
                            </span> */}
                            {/*end::Link*/}
                            {/*begin::Link*/}
                            {/*end::Link*/}
                            {/*begin::Link*/}
                            <span
                              onClick={() => history.push(`${`/informacion-publica-de-oficio`}`)}
                              className="text-white  text-white text-hover-dark fs-5 mb-6"
                            >
                              Información Pública de Oficio
                            </span>
                            <span
                              onClick={() => history.push(`${`/fotos-y-videos`}`)}
                              className="text-white  text-white text-hover-dark fs-5 mb-6"
                            >
                              Fotos y Videos
                            </span>
                            <span
                              onClick={() => history.push(`${`/sedes`}`)}
                              className="text-white  text-white text-hover-dark fs-5 mb-6"
                            >
                              Sedes de Entrenamiento
                            </span>
                            {/* <span
                              onClick={() => history.push(`${`/contacto`}`)}
                              className="text-white  text-white text-hover-dark fs-5 mb-6"
                            >
                              Contacto
                            </span> */}
                            {/*end::Link*/}
                          </div>
                          {/*end::Links*/}
                          {/*begin::Links*/}

                          {/*end::Links*/}
                        </div>
                        {/*end::Navs*/}
                      </Col>
                      {/*end::Col*/}
                    </Row>
                    {/*end::Row*/}
                  </div>
                  {/*end::Container*/}
                  {/*begin::Separator*/}
                  {/* <div className="landing-dark-separator" /> */}
                  {/*end::Separator*/}
                  {/*begin::Container*/}
                  <div className="p-5 text-center" >
                    <span
                      className="text-center text-white fs-4"
                    >
                      Copyright &copy; {new Date().getFullYear()} Federación Deportiva Nacional De Atletismo

                    </span>
                    {/*end::Logo image*/}

                  </div>
                  {/*end::Container*/}
                </div>
                {/*end::Wrapper*/}
              </div>
              {/*FOOTER FIN*/}

            </div>
          </div>
        </div>
      </div>
    </Suspense>

  )
}
